/**
 * Global Search Sagas
 */

import {
  call,
  put,
  takeLatest,
  debounce,
  select,
  type SagaReturnType,
} from '@spcc/core'
import { globalSearchActions } from './global-search.slice'
import { globalSearchApi } from '../infrastructure/api/global-search-api'
import { selectSearchPortal } from './global-search.selectors'

function* searchSaga(action: ReturnType<typeof globalSearchActions.searchRequest>) {
  const query = action.payload

  if (!query || query.trim().length < 2) {
    yield put(globalSearchActions.searchSuccess({ results: [], total: 0 }))
    return
  }

  try {
    const portal: ReturnType<typeof selectSearchPortal> = yield select(selectSearchPortal)
    const response: SagaReturnType<typeof globalSearchApi.search> = yield call(
      globalSearchApi.search,
      { query, portal, limit: 20 }
    )
    yield put(
      globalSearchActions.searchSuccess({
        results: response.results,
        total: response.total,
      })
    )
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Search failed'
    yield put(globalSearchActions.searchFailure(message))
  }
}

export function* globalSearchSaga() {
  yield debounce(300, globalSearchActions.searchRequest.type, searchSaga)
}
